import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ForecastWeather.css";
import WeatherForecastCalculation from "./WeatherForecastCalculation.js";

export default function ForecastWeather(props) {
  const [loaded, setLoaded] = useState(false);
  const [forecast, setForecast] = useState(null);

  useEffect(() => {
    setLoaded(false);
  }, [props.coordinates]);

  function displayForecast(response) {
    setForecast(response.data.daily);
    setLoaded(true);
  }

  if (loaded) {
    return (
      <div className="WeatherForecast">
        <div className="container-fluid">
          <div className="row">
            {forecast.map(function (dailyForecast, index) {
              if (index < 6) {
                return (
                  <div className="col-6 col-sm-4 col-md-2" key={index}>
                    <WeatherForecastCalculation
                      data={dailyForecast}
                      unit={props.unit}
                    />
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      </div>
    );
  } else {
    let apiKey = "f3b0d7fc3c211aec3174c405320dd931";
    let longitude = props.coordinates.lon;
    let latitude = props.coordinates.lat;
    let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric`;

    axios.get(apiUrl).then(displayForecast);

    return null;
  }
}
